import React from 'react'
import { Radio, Tooltip } from 'antd'
import './index.css'

const FormRadioButton = ({
  label,
  icon,
  value,
  radioLabelTextStyles = {},
  radioButtonStyles = {},
  radioButtonContentStyle = {},
  id = '',
  onClick,
  radioButtonLarge = false,
  disabled = false,
  tooltip = { title: '', placement: 'top' },
}) => {
  return (
    <Radio.Button
      className={radioButtonLarge ? 'radioButtonLarge radioButton' : 'radioButton'}
      value={value}
      onClick={onClick}
      style={radioButtonStyles}
      disabled={disabled}
    >
      <Tooltip title={tooltip.title} placement={tooltip.placement}>
        <div id={id} className="radioButtonContent" style={radioButtonContentStyle}>
          <div role="img" aria-label={label} className="radioLabelIcon">
            {icon}
          </div>
          <div className="radioLabelText" style={radioLabelTextStyles}>
            {label}
          </div>
        </div>
      </Tooltip>
    </Radio.Button>
  )
}

export default FormRadioButton
